<template>
  <div>
      <!-- <RadioGroup type="button" v-model="innervalue" class="sl-radio-tag" @on-change="handleChangeShortcut">
        <Radio :label="item.type" v-for="item in shortcuts">{{item.text}}</Radio>
        <DatePicker :transfer="true" confirm :open="open" v-model="data" :type="type" placement="bottom-end" placeholder="请选择时间段" @on-clickoutside="handleOutside" @on-ok="handleChange">
          <label @click="handleClickCustom" :class="{'ivu-radio-wrapper-checked':innervalue=='datepicker'}" class="ivu-radio-wrapper ivu-radio-group-item ivu-radio-default">{{customTimelabel}}</label>
        </DatePicker>
      </RadioGroup> -->
      <TimePicker :value="innervalue" format="HH:mm" type="timerange" placement="bottom-end" placeholder="请选择时间段" @on-change="handleChange"></TimePicker>
  </div>
</template>
<script>
import { moment } from '@/util'

const shortcutsType = {
  'today': {
    text: '今日',
    value: ['$d', '+1d'],
  },
  'yesterday': {
    text: '昨日',
    value: ['-1$d', '$d'],
  },
  'week': {
    text: '本周',
    value: ['$w', 'w'],
  },
  'lastweek': {
    text: '上周',
    value: ['-1$w', '$w'],
  },
  'month': {
    text: '本月',
    value: ['$M', 'M'],
  },
  'lastmonth': {
    text: '上月',
    value: ['-1$M', '$M'],
  }
}

const isValidDate = (d) => {
  return d && d.length && d[0] && d[1]
}
export default {
  name: 'sl-search-time',
  data() {
    return {
      data: [],
      open:false,
      shortcut: null,
      lastOption:'',
      innervalue:'',
      customTime:[],
    }
  },
  props: {
    field: {
      type: String
    },
    value: null,
    options: {
      type: Object,
      default(){
        return {

        }
      }
    }
  },

  computed: {
    customTimelabel(){
      const format = this.options.type == 'time' ? 'HH:mm' : 'HH:mm:ss'
      if( this.innervalue == 'time' && isValidDate(this.customTime) ){
        return this.data.map(i => moment(i, format)).join(' ~ ')
      }else{
        return '自定义'
      }
    },
    type(){
      return this.options.type || 'timerange'
    },
    shortcuts() {
      if (this.options.shortcuts.length) {
        let ret = []

        this.options.shortcuts.forEach(i => {
          let opts = shortcutsType[i]
          if(opts){
            ret.push({
              text:opts.text , 
              type:i,
              value : () => opts.value.map(i => moment(i, 'hh:mm:ss')),
              onClick:()=>{
                this.shortcut = opts.text
              }
            })
          }
        })
        return ret
      } else {
        return []
      }
    }
  },
  watch: {
    value(v) {
      if(v === null){
        this.data = []
        this.innervalue = ''
        this.customTime = []
        this.open = false
      }
    },
    innervalue(nv,ov){
      this.lastOption = ov
    }
  },
  methods: {
    handleChangeShortcut(v){
      this.open = false
      this.customTime = []
      let hit = shortcutsType[v]
      let pubData = hit.value.map(i => moment(i , 'ms'))
      this.$emit('change', this.field, pubData, hit.text)
    },
    handleChange(v) {
      // let pubData = this.data.map(i => i.getTime())
      // this.customTime = [...this.data]
      // this.innervalue = 'timepicker'
      // this.open = false
      // this.$emit('change', this.field, pubData, this.customTimelabel)
      this.$emit('change', this.field, v, v.join('~'))
    },
    handleOutside(){
      this.open = false
      if(!isValidDate(this.data)){
        this.innervalue = this.lastOption
      }
    },
    handleClickCustom(){
      this.open = true
      console.log( 'process' )
      this.$emit('process' , true)
    }
  }
}

</script>